import { useOrderDetails } from 'hooks/use-order-details';

import { IUseRefundEligibilityOptions, IUseRefundEligibiltyResponse } from './types';
import { useCheckOrderRefundEligibility } from './use-check-order-refund-eligibility';
import { useCheckUserRefundEligibility } from './use-check-user-refund-eligibility';
import { getFirstMessage } from './utils';

/*
 * Determines whether or not a user and the order permit performing
 * a customer initiated refund.
 *
 * Includes details about the refund eligibility along with
 * reason text for messaging.
 */
export const useRefundEligibility = ({
  preloadedOrder,
  orderId
}: IUseRefundEligibilityOptions = {}): IUseRefundEligibiltyResponse => {
  const { order: retrievedOrder, loading: isOrderLoading } = useOrderDetails(orderId);

  const order = preloadedOrder || retrievedOrder;

  const orderEligibilityData = useCheckOrderRefundEligibility(order);
  const userEligibilityData = useCheckUserRefundEligibility();
  const { loading: isUserRefundEligibilityLoading } = userEligibilityData;

  const refundIneligibilityReason = getFirstMessage([
    userEligibilityData.refundIneligibilityReason,
    orderEligibilityData.refundIneligibilityReason
  ]);

  return {
    ...orderEligibilityData,
    ...userEligibilityData,
    refundIneligibilityReason,
    isDeterminingRefundEligibility:
      isUserRefundEligibilityLoading || (!preloadedOrder && isOrderLoading)
  };
};
